export default [
  {
    path: "/coletorlist ",
    name: "ColetorList",
    component: () => import("@/components/ColetorList.vue"),
  },
  {
    path: "/echarts",
    name: "Echarts",
    component: () => import("@/components/Echarts.vue"),
  },
]